import { useRef, useState } from 'react';
import { apiFetch } from '../lib/api-client';
import { Dialog } from './controls';

export function CancelDispatchButton({ path, name, disabled = false, onSaved }: {
 path:string; name?:string; disabled?:boolean; onSaved:()=>void|Promise<void>;
}) {
 const [open,setOpen]=useState(false), [loading,setLoading]=useState(false), [saving,setSaving]=useState(false);
 const [version,setVersion]=useState(''), [error,setError]=useState('');
 const pending=useRef(false);
 const read=async()=>{
  setLoading(true);setVersion('');setError('');
  try {
   const response=await apiFetch(path), payload=await response.json();
   if(!response.ok || !payload.data?.item?.version) throw new Error(payload.error?.message || 'Unable to check this dispatch.');
   setVersion(payload.data.item.version);
  } catch(cause) {setError(cause instanceof Error?cause.message:'Unable to check this dispatch.');}
  finally {setLoading(false);}
 };
 return <>
  <button type="button" disabled={disabled} aria-label={name?`Cancel dispatch for ${name}`:'Cancel dispatch'} className="min-h-11 rounded-lg border border-[var(--line)] px-3 py-2 text-sm font-semibold disabled:opacity-50" onClick={()=>{setOpen(true);void read();}}>Cancel dispatch</button>
  {open && <Dialog title={name?`Cancel dispatch · ${name}`:'Cancel accidental dispatch'} onClose={()=>{if(!pending.current && !loading)setOpen(false);}}>
   <div className="space-y-4">
    <p>This returns {name || 'you'} to scheduled status and removes the accidental travel time from payable time. The appointment stays booked, and an audit record keeps the original times.</p>
    <p className="text-sm text-[var(--ink-soft)]">Any “on my way” text already sent cannot be recalled.</p>
    {loading && <p role="status">Checking dispatch…</p>}
    {error && <p role="alert">{error}</p>}
    <div className="flex flex-wrap justify-end gap-3">
     <button type="button" disabled={saving || loading} className="min-h-11 rounded-lg border px-4 py-2" onClick={()=>setOpen(false)}>Keep dispatch</button>
     {error && <button type="button" disabled={saving || loading} className="min-h-11 underline" onClick={()=>void read()}>Reload dispatch</button>}
     <button type="button" disabled={!version || saving || loading} className="min-h-11 rounded-lg bg-[var(--accent)] px-4 py-2 text-white disabled:opacity-50" onClick={async()=>{
      if(pending.current)return;
      pending.current=true;setSaving(true);setError('');
      try {
       const response=await apiFetch(path,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({version})});
       const payload=await response.json();
       if(!response.ok)throw new Error(payload.error?.message || 'Could not cancel dispatch.');
       await onSaved();setOpen(false);
      } catch(cause){setVersion('');setError(cause instanceof Error?cause.message:'Could not cancel dispatch.');}
      finally {pending.current=false;setSaving(false);}
     }}>{saving?'Cancelling…':'Confirm cancel dispatch'}</button>
    </div>
   </div>
  </Dialog>}
 </>;
}
